import { ChevronLeft, ChevronRight } from "lucide-react";
import PropTypes from "prop-types";
import { Card } from "./Card";
import { cn } from "../helpers";
import { useEffect } from "react";
import { paginationService } from "../state/pagination";

const DataTable = ({
  label,
  children,
  pages = true,
  dataFrom = 0,
  dataTo = 0,
  total = 0,
  disablePrev = false,
  disableNext = false,
  filter,
  className,
  nextPage = () => void null,
  prevPage = () => void null,
}) => {
  useEffect(() => {
    paginationService.setPagination(<></>);
  }, []);

  return (
    <Card className={cn("flex h-full min-h-0 flex-col overflow-hidden bg-slate-50", className)}>
      {(label || filter) && (
        <div className="flex shrink-0 flex-wrap items-center justify-between gap-3 border-b border-slate-200 bg-white px-6 py-3.5">
          <div className="min-w-0 text-base font-semibold text-slate-800">{label}</div>
          {filter && <div className="flex min-w-0 items-center gap-3">{filter}</div>}
        </div>
      )}
      <div className="data-table-scroll min-h-0 min-w-0 flex-1 overflow-auto">{children}</div>
      {pages && (
        <div className="flex shrink-0 flex-wrap items-center justify-between gap-3 border-t border-slate-200 bg-white px-5 py-3">
          <div className="text-xs text-slate-500">
            Menampilkan{" "}
            <span className="font-medium text-slate-700">
              {dataFrom}-{dataTo}
            </span>{" "}
            dari <span className="font-medium text-slate-700">{total.toLocaleString("id-ID")}</span>
          </div>
          <div className="flex items-center gap-2">
            <button
              type="button"
              onClick={prevPage}
              disabled={disablePrev}
              aria-label="Halaman sebelumnya"
              className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:border-slate-100 disabled:bg-slate-50 disabled:text-slate-300"
            >
              <ChevronLeft size={16} /> Sebelumnya
            </button>
            <button
              type="button"
              onClick={nextPage}
              disabled={disableNext}
              aria-label="Halaman selanjutnya"
              className="inline-flex h-9 items-center gap-1.5 rounded-lg border border-slate-200 bg-white px-3 text-sm font-medium text-slate-600 transition hover:border-slate-300 hover:bg-slate-50 disabled:cursor-not-allowed disabled:border-slate-100 disabled:bg-slate-50 disabled:text-slate-300"
            >
              Selanjutnya <ChevronRight size={16} />
            </button>
          </div>
        </div>
      )}
    </Card>
  );
};

DataTable.propTypes = {
  label: PropTypes.node,
  children: PropTypes.node,
  pages: PropTypes.bool,
  dataFrom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  dataTo: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.number,
  disablePrev: PropTypes.bool,
  disableNext: PropTypes.bool,
  filter: PropTypes.node,
  className: PropTypes.string,
  nextPage: PropTypes.func,
  prevPage: PropTypes.func,
};

export default DataTable;
